import { contactContent } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            有独家爆料？欢迎与我们取得联系
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 text-center">
            {contactContent.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            {contactContent.methods.map((method) => (
              <div
                key={method.label}
                className="flex flex-col items-center text-center p-5 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                  <i className={`${method.icon} text-xl`}></i>
                </div>
                <span className="text-xs font-semibold text-foreground-500 mb-1">
                  {method.label}
                </span>
                <span className="text-sm font-medium text-foreground-800 break-all">
                  {method.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}